import * as THREE from "three";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader.js";



import 'normalize.css';
import style from './styles/index.less';
import './logo.svg';

/** 1) Ваш SVG как строка */
const svgText = String.raw`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="847.666" height="687.344" viewBox="0 0 847.666 687.344">
  <defs>
    <linearGradient id="linear-gradient" x1="0.441" y1="0.345" x2="0.423" y2="0.213" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="linear-gradient-2" x1="0.51" y1="0.467" x2="0.522" y2="0.883" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-3" x1="0.297" y1="0.415" x2="0.348" y2="0.37" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-4" x1="2.423" y1="0.35" x2="2.269" y2="0.362" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-5" x1="0.247" y1="0.616" x2="0.099" y2="0.663" xlink:href="#linear-gradient"/>
    <linearGradient id="linear-gradient-6" x1="-0.748" y1="-0.47" x2="-1.505" y2="-1.058" xlink:href="#linear-gradient"/>
  </defs>
  <g id="Сгруппировать_34856" data-name="Сгруппировать 34856" transform="translate(-901 -245)" opacity="0.3">
    <g id="Сгруппировать_34855" data-name="Сгруппировать 34855" transform="translate(1975.055 -24.8)">
      <g id="Path_36843" data-name="Path 36843">
        <path id="Контур_36843" data-name="Контур 36843" d="M-1074.055,933.415l2.5-2.518,348-351,1.42,1.408-345.5,348.482L-242.584,728-421.639,497.215l1.58-1.226,180.945,233.218Z" fill="url(#linear-gradient)"/>
      </g>
      <g id="Path_36844" data-name="Path 36844">
        <path id="Контур_36844" data-name="Контур 36844" d="M-746.315,427.819l-243.3-128.406,3.724-.144,759.5-29.469L-398.621,386.43l-1.121-1.656,166.434-112.7-748.778,29.053,236.7,124.928Z" fill="url(#linear-gradient-2)"/>
      </g>
      <path id="Контур_36845" data-name="Контур 36845" d="M-228.382,567.189-456.223,584.4l.15,1.994,222.159-16.785L-577.37,889.9v.48l-68.29,63.683L-921.934,530.243-692.31,649.489l.922-1.775L-927.764,524.961l281.727,432.183,415.571-388.012Z" fill="url(#linear-gradient-3)"/>
      <path id="Контур_36846" data-name="Контур 36846" d="M-708.926,857l-213-326.757L-771,608.622v-2.254l-156.759-81.407L-711.313,857Z" fill="url(#linear-gradient-4)"/>
      <path id="Контур_36847" data-name="Контур 36847" d="M-367.335,694.037-577.366,889.9v.48l-68.29,63.683L-683.044,896.7h-2.388l39.4,60.441,281.638-263.107Z" fill="#fff"/>
      <path id="Контур_36848" data-name="Контур 36848" d="M-456.218,584.4l.15,1.994,222.159-16.785-89.579,83.535h2.933l90.095-84.016,2.083-1.943Z" fill="url(#linear-gradient-5)"/>
      <path id="Контур_36849" data-name="Контур 36849" d="M-382.407,578.8V580.8l148.494-11.219-198.381,185h3.447L-230.465,569.1l2.083-1.943Z" fill="url(#linear-gradient-6)"/>
    </g>
  </g>
</svg>`;

/** 2) Карта градиентов (как в SVG) */
const gradients = {
  "linear-gradient":   { x1: 0.441, y1: 0.345, x2: 0.423, y2: 0.213 },
  "linear-gradient-2": { x1: 0.510, y1: 0.467, x2: 0.522, y2: 0.883 },
  "linear-gradient-3": { x1: 0.297, y1: 0.415, x2: 0.348, y2: 0.370 },
  "linear-gradient-4": { x1: 2.423, y1: 0.350, x2: 2.269, y2: 0.362 },
  "linear-gradient-5": { x1: 0.247, y1: 0.616, x2: 0.099, y2: 0.663 },
  "linear-gradient-6": { x1: -0.748, y1: -0.470, x2: -1.505, y2: -1.058 },
};

function extractGradientId(fill) {
  const m = /url\(#([^)]+)\)/.exec(fill || "");
  return m ? m[1] : null;
}

/** 3) Нормализация UV в 0..1 (под objectBoundingBox) */
function normalizeUV(geometry) {
  geometry.computeBoundingBox();
  const bb = geometry.boundingBox;
  const size = new THREE.Vector2(
    Math.max(1e-6, bb.max.x - bb.min.x),
    Math.max(1e-6, bb.max.y - bb.min.y)
  );

  const pos = geometry.attributes.position;
  const uv = geometry.attributes.uv;
  if (!uv) return;

  for (let i = 0; i < pos.count; i++) {
    const x = pos.getX(i);
    const y = pos.getY(i);
    uv.setXY(i, (x - bb.min.x) / size.x, (y - bb.min.y) / size.y);
  }
  uv.needsUpdate = true;
}

/** Helper: Get primary color from CSS variable */
function getPrimaryColor() {
  const colorStr = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
  return new THREE.Color(colorStr || '#ffffff');
}

/** 4) Материал градиента: primary-color -> transparent по направлению (x1,y1)->(x2,y2) */
function makeLinearFadeMaterial({ x1, y1, x2, y2, baseOpacity = 0.3 }) {
  const start = new THREE.Vector2(x1, y1);
  const end = new THREE.Vector2(x2, y2);
  const primaryColor = getPrimaryColor();

  const dir = new THREE.Vector2().subVectors(end, start);
  const len = Math.max(1e-6, dir.length());
  dir.divideScalar(len);

  return new THREE.ShaderMaterial({
    transparent: true,
    depthWrite: false,
    depthTest: false,
    side: THREE.DoubleSide,
    uniforms: {
      uStart: { value: start },
      uDir: { value: dir },
      uLen: { value: len },
      uBaseOpacity: { value: baseOpacity },
      uColor: { value: primaryColor },
    },
    vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      uniform vec2 uStart;
      uniform vec2 uDir;
      uniform float uLen;
      uniform float uBaseOpacity;
      uniform vec3 uColor;
      varying vec2 vUv;

      void main() {
        float t = dot(vUv - uStart, uDir) / uLen;
        t = clamp(t, 0.0, 1.0);

        // stop(0)=primary-color (alpha 1), stop(1)=primary-color (alpha 0)
        float a = (1.0 - t) * uBaseOpacity;

        gl_FragColor = vec4(uColor, a);
      }
    `,
  });
}

/** 5) Мини-сцена (OrthographicCamera удобно для “2D как SVG”) */
const scene = new THREE.Scene();

const container = document.getElementById('hero-canvas-container');
const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
if (container) {
  renderer.setSize(container.clientWidth, container.clientHeight);
  container.appendChild(renderer.domElement);
} else {
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.appendChild(renderer.domElement);
}
renderer.setClearAlpha(0);

// Камера будет подогнана под бокс объекта
const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, -1000, 1000);
camera.position.set(0, 0, 10);
camera.lookAt(0, 0, 0);

const svgGroup = new THREE.Group();
scene.add(svgGroup);

// SVG обычно “Y вниз”, а в three.js “Y вверх”
svgGroup.scale.y *= -1;

/** 6) Парсим SVG и строим меши */
const loader = new SVGLoader();
const svgData = loader.parse(svgText);

for (const path of svgData.paths) {
  const style = path.userData?.style || {};
  const fill = style.fill;

  const shapes = SVGLoader.createShapes(path);
  for (const shape of shapes) {
    const geom = new THREE.ShapeGeometry(shape);
    normalizeUV(geom);

    const gradId = extractGradientId(fill);

    let mat;
    if (gradId && gradients[gradId]) {
      mat = makeLinearFadeMaterial({ ...gradients[gradId], baseOpacity: 0.3 });
    } else {
      // fill="#fff" (у вас один такой path)
      mat = new THREE.MeshBasicMaterial({
        color: getPrimaryColor(),
        transparent: true,
        opacity: 0.3,
        depthWrite: false,
        depthTest: false,
        side: THREE.DoubleSide,
      });
    }

    const mesh = new THREE.Mesh(geom, mat);
    svgGroup.add(mesh);
  }
}

/** 7) Подгоняем камеру под размер объекта */
function fitOrthoCameraToObject(cam, object, padding = 1.1) {
  const box = new THREE.Box3().setFromObject(object);
  const size = box.getSize(new THREE.Vector3());
  const center = box.getCenter(new THREE.Vector3());

  const halfW = (size.x * padding) / 2;
  const halfH = (size.y * padding) / 2;

  cam.left = -halfW;
  cam.right = halfW;
  cam.top = halfH;
  cam.bottom = -halfH;

  cam.position.set(center.x, center.y, 10);
  cam.lookAt(center.x, center.y, 0);
  cam.updateProjectionMatrix();
}

fitOrthoCameraToObject(camera, svgGroup, 1.15);

// Store initial positions for animation
const meshes = [];
svgGroup.traverse((child) => {
  if (child.isMesh) {
    child.userData.initialPosition = child.position.clone();
    child.userData.initialOpacity = child.material.opacity || child.material.uniforms?.uBaseOpacity?.value || 0.3;
    child.material.opacity = 0;
    if (child.material.uniforms?.uBaseOpacity) {
      child.material.uniforms.uBaseOpacity.value = 0;
    }
    meshes.push(child);
  }
});

// Animation timing
const animationStartTime = performance.now();
const fadeInDuration = 2000; // 2 seconds total fade in
const staggerDelay = 150; // delay between each path

/** 8) Рендер-цикл + ресайз */
function animate() {
  requestAnimationFrame(animate);
  
  const elapsed = performance.now() - animationStartTime;
  
  // Staggered fade-in animation for each mesh
  meshes.forEach((mesh, index) => {
    const meshStart = index * staggerDelay;
    const meshElapsed = elapsed - meshStart;
    
    if (meshElapsed > 0) {
      const progress = Math.min(meshElapsed / fadeInDuration, 1);
      // Ease out cubic for smooth animation
      const eased = 1 - Math.pow(1 - progress, 3);
      const targetOpacity = mesh.userData.initialOpacity * eased;
      
      if (mesh.material.uniforms?.uBaseOpacity) {
        mesh.material.uniforms.uBaseOpacity.value = targetOpacity;
      } else {
        mesh.material.opacity = targetOpacity;
      }
    }
  });
  
  // Gentle floating animation
  const floatTime = elapsed * 0.001;
  svgGroup.position.y = Math.sin(floatTime * 0.5) * 5;
  svgGroup.position.x = Math.sin(floatTime * 0.3) * 3;
  
  // Subtle rotation
  svgGroup.rotation.z = Math.sin(floatTime * 0.2) * 0.02;
  
  renderer.render(scene, camera);
}
animate();

window.addEventListener("resize", () => {
  if (container) {
    renderer.setSize(container.clientWidth, container.clientHeight);
  } else {
    renderer.setSize(window.innerWidth, window.innerHeight);
  }
  // В orthographic-камере мы “фитим” по миру, так что пересчёт не обязателен.
});


async function setLang(lang) {
    const dict = await fetch(`/i18n/${lang}.json`).then(r => r.json());
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.dataset.i18n;
      el.innerHTML = key.split('.').reduce((o,k)=>o?.[k], dict) ?? el.textContent;
    });
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
  }

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
    
    // Update SVG colors based on new theme
    setTimeout(() => {
      const newColor = getPrimaryColor();
      meshes.forEach((mesh) => {
        if (mesh.material.uniforms?.uColor) {
          mesh.material.uniforms.uColor.value = newColor;
        } else if (mesh.material.color) {
          mesh.material.color = newColor;
        }
      });
    }, 50); // Small delay to ensure CSS variables are updated
  }

  const policyNotice = document.getElementById('policy-notice');
  const policyAcknowledged = localStorage.getItem('policyNoticeAcknowledged') === '1';
  if (policyNotice) {
    policyNotice.classList.toggle('policy-notice--hidden', policyAcknowledged);
  }

  const burgerMenu = document.getElementById('burger-menu');
  const navLinks = document.getElementById('navigation-links');

  document.addEventListener('click', (e) => {
    const langBtn = e.target.closest('[data-lang]');
    if (langBtn) {
      setLang(langBtn.dataset.lang);
      burgerMenu?.classList.remove('active');
      navLinks?.classList.remove('active');
    }

    const themeBtn = e.target.closest('[data-theme-toggle]');
    if (themeBtn) {
      const currentTheme = document.documentElement.getAttribute('data-theme') || 'dark';
      setTheme(currentTheme === 'dark' ? 'light' : 'dark');
      burgerMenu?.classList.remove('active');
      navLinks?.classList.remove('active');
    }

    const burgerBtn = e.target.closest('#burger-menu');
    if (burgerBtn) {
      burgerMenu?.classList.toggle('active');
      navLinks?.classList.toggle('active');
    }

    const navLink = e.target.closest('#navigation-links a');
    if (navLink) {
      burgerMenu?.classList.remove('active');
      navLinks?.classList.remove('active');
    }

    const ackBtn = e.target.closest('[data-policy-ack]');
    if (ackBtn) {
      policyNotice?.classList.add('policy-notice--hidden');
      localStorage.setItem('policyNoticeAcknowledged', '1');
    }
  });

  setLang(localStorage.getItem('lang') || 'en');
  setTheme(localStorage.getItem('theme') || 'dark');

  
console.log('App initialized');
